<div class="modelContainer alignCenter">
  <div class="modelTitle heading2">
    <span>Dependant Variables</span>
  </div>

  <div class="modelBody regularText">
    <div class="row mt-2">
      <div class="col-3">
        <label class="mandatory-field largeText" for="cleansingQualifier">Name</label>
      </div>
      <div class="col-8">
        <input id="cleansingQualifier" type="text" class="form-control largeText mb-1" [(ngModel)]="searchedTagName"
               [typeahead]="tagNameList" [typeaheadOptionField]="'tagName'" [typeaheadOptionsLimit]="5" (typeaheadOnSelect)="onTagNameSelectedKnn($event)"
               autocomplete="off" tabindex="-1" [disabled]="disableKnnBlockQualifier()" />
        <mat-chip-listbox #chipList>
          <mat-chip-option *ngFor="let element of selectedTags, let i = index" [removable]="true" (removed)="remove(i)">
            <span *ngIf="element.length<=25">{{element}}</span>
            <span *ngIf="element.length>25" matTooltip={{element}}>{{element.slice(0,25)}}</span>
            <span *ngIf="element.length>25" matTooltip="{{element}}">...</span>
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip-option>
        </mat-chip-listbox>
      </div>
      <div class="col-1"></div>
    </div>
    <div class="d-flex alignCenter mt-2 mb-2">
      <button id="createBtn" type="submit" class="saveBtn2 primaryBtn" (click)="saveDependantVariables()" [disabled]="disableSave()">Save</button>
    </div>
  </div>
</div>
